module.exports = __webpack_public_path__ + "img/kb-article.6977451e.jpg";